import React from "react";
import { AppearanceContextType, useAppearanceContext } from "@contexts/AppearanceContext";
import SpaceView from "../SpaceView";
import "./LoadingView.scss";
import LifeAtLogo from "/resources/logos/LifeAt-Logo-Large.svg";

const LOADING_GIF = "https://media2.giphy.com/media/drJqKQbUcEjndHdCmN/giphy.gif";

interface LoadingViewProps {
    isAppLoading: boolean;
}

/**
 * @deprecated Will leave this around for now in case we decide we want to use it for something.
 * @param props
 * @constructor
 */
export default function LoadingView(props: LoadingViewProps) {
    const { lightMode }: AppearanceContextType = useAppearanceContext();

    const loadingFrame: JSX.Element = (
        <div className={`loading-img`}>
            <LifeAtLogo className={`load-logo ${lightMode ? "light" : "dark"}`} />
            <img className="load-bar" src={LOADING_GIF} alt="" />
        </div>
    );

    return (
        <div className={`loading-container ${lightMode ? "light" : "dark"}`}>
            <SpaceView frameObj={loadingFrame} isVisible={props.isAppLoading} />
        </div>
    );
}
